"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastMessages = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var useDrillValidationMessages_1 = require("./useDrillValidationMessages");
var model_1 = require("../../../model");
/**
 * @internal
 */
exports.ToastMessages = function () {
    var _a = react_1.useContext(sdk_ui_kit_1.ToastMessageContext), toastMessages = _a.messages, removeToastMessage = _a.removeMessage, removeAllToastMessages = _a.removeAllMessages;
    var _b = useDrillValidationMessages_1.useDrillValidationMessages(), drillValidationMessages = _b.messages, removeDrillValidationMessage = _b.removeMessage, removeAllDrillValidationMessages = _b.removeAllMessages;
    var renderMode = model_1.useDashboardSelector(model_1.selectRenderMode);
    // remove all messages whenever the render mode changes
    react_1.useEffect(function () {
        removeAllToastMessages();
        removeAllDrillValidationMessages();
    }, [removeAllDrillValidationMessages, removeAllToastMessages, renderMode]);
    var messages = react_1.useMemo(function () { return tslib_1.__spread(toastMessages, drillValidationMessages); }, [toastMessages, drillValidationMessages]);
    var removeMessage = react_1.useCallback(
    // try removing the id from both collections
    function (id) {
        removeToastMessage(id);
        removeDrillValidationMessage(id);
    }, [removeDrillValidationMessage, removeToastMessage]);
    if (messages.length > 0) {
        return react_1.default.createElement(sdk_ui_kit_1.Messages, { messages: messages, onMessageClose: removeMessage });
    }
    return null;
};
//# sourceMappingURL=ToastMessages.js.map